import { gsap } from "gsap";

const mobilebar = () => {
  let isOpen = false;
  const trigger = document.querySelector(".mobilebar-burger");
  const bars = trigger.querySelectorAll("div");
  const dropdown = document.querySelector(".mobilebar-dropdown");
  trigger.addEventListener("click", () => {
    if (!isOpen) {
      isOpen = true;
      document.body.style.overflow = "hidden";
      const duration = 0.5;
      const ease = "elastic.out(1,0.3)";
      gsap.to(bars[0], { x: 2, rotate: "45", scaleX: 0.533, duration, ease });
      gsap.to(bars[1], { rotate: -45, scaleX: 1.157, duration, ease });
      gsap.to(bars[2], { x: -2, rotate: "45", scaleX: 0.533, duration, ease });
      gsap.to(dropdown, {
        opacity: 1,
        scale: 1,
        duration: 0.3,
        ease: "power4.out",
      });
      dropdown.style.pointerEvents = "auto";
    } else {
      isOpen = false;
      document.body.style.overflow = "auto";
      const duration = 0.3;
      const ease = "power4.out";
      gsap.to(bars[0], { x: 0, rotate: "0", scaleX: 1, duration, ease });
      gsap.to(bars[1], { rotate: 0, scaleX: 1, duration, ease });
      gsap.to(bars[2], { x: 0, rotate: "0", scaleX: 1, duration, ease });
      gsap.to(dropdown, {
        opacity: 0,
        scale: 0.9,
        duration: 0.3,
        ease: "power4.out",
      });
      dropdown.style.pointerEvents = "none";
    }
  });
};

export default mobilebar;
